/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Project } from '../models/Project';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ProjectsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get a project
     * @param workspaceId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public projectsGet(
        workspaceId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Project;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/projects/{workspaceId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update a project
     * @param workspaceId
     * @param id
     * @param requestBody The project properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public projectsPut(
        workspaceId: string,
        id: string,
        requestBody: {
            /**
             * Name of the project
             */
            name: string;
            /**
             * Description of the project
             */
            description: string;
            slug: string;
            ownerId: string;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Project;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v1/projects/{workspaceId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Update the fields of a project
     * @param workspaceId
     * @param id
     * @param requestBody The project properties to update
     * @returns any Successful request
     * @throws ApiError
     */
    public projectsPatch(
        workspaceId: string,
        id: string,
        requestBody: {
            /**
             * Name of the project
             */
            name?: string;
            /**
             * Description of the project
             */
            description?: string;
            slug?: string;
            ownerId?: string;
        },
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Project;
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v1/projects/{workspaceId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Delete a project
     * @param workspaceId
     * @param id
     * @returns any Successful request
     * @throws ApiError
     */
    public projectsDel(
        workspaceId: string,
        id: string,
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: {
            /**
             * ID of the project
             */
            id: string;
            _object: 'project';
        };
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/projects/{workspaceId}/{id}',
            path: {
                'workspaceId': workspaceId,
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * List projects
     * @param workspaceId
     * @param orderBy
     * @param perPage
     * @param page
     * @param order
     * @param name
     * @param description
     * @param createdBy
     * @param ownerId
     * @param slug
     * @param lastEditedBy
     * @returns any Successful request
     * @throws ApiError
     */
    public projectsList(
        workspaceId: string,
        orderBy: 'id' | 'name' | 'description' | 'createdBy' | 'ownerId' | 'slug' | 'lastEditedBy' | 'created' | 'updated' = 'created',
        perPage: string = '20',
        page: string = '1',
        order: 'asc' | 'desc' = 'desc',
        name?: (string | Array<string>),
        description?: (string | Array<string>),
        createdBy?: (string | Array<string>),
        ownerId?: (string | Array<string>),
        slug?: (string | Array<string>),
        lastEditedBy?: (string | Array<string>),
    ): CancelablePromise<{
        message: {
            message: 'Successful request';
        };
        success: boolean;
        error: any;
        result: Array<Project>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/projects/{workspaceId}',
            path: {
                'workspaceId': workspaceId,
            },
            query: {
                'orderBy': orderBy,
                'perPage': perPage,
                'page': page,
                'order': order,
                'name': name,
                'description': description,
                'createdBy': createdBy,
                'ownerId': ownerId,
                'slug': slug,
                'lastEditedBy': lastEditedBy,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
    /**
     * Create a new project
     * @param requestBody The project to create
     * @returns any Resource created
     * @throws ApiError
     */
    public projectsPost(
        requestBody: {
            /**
             * ID of the workspace
             */
            workspaceId: string;
            /**
             * Name of the project
             */
            name: string;
            /**
             * Description of the project
             */
            description?: string | null;
        },
    ): CancelablePromise<{
        message: {
            message: 'Resource created';
        };
        success: boolean;
        error: any;
        result: Project;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/projects/',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                500: `Internal error`,
            },
        });
    }
}
